module.exports = __webpack_public_path__ + "img/er4.169f273b.png";